import { InteractionManager } from "react-native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { UserLoggedInNavigatorParamList } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { useNavigation } from "@react-navigation/native";
import { graphql, useMutation } from "react-relay";
import { useOpenFileMutation } from "./__generated__/useOpenFileMutation.graphql";

export const useOpenFile = () => {
  const navigation: NativeStackNavigationProp<UserLoggedInNavigatorParamList> =
    useNavigation();

  const [accessFile] = useMutation<useOpenFileMutation>(graphql`
    mutation useOpenFileMutation($fileId: ID!, $position: Int, $queryId: ID) {
      file(id: $fileId) {
        access(position: $position, queryId: $queryId)
      }
    }
  `);

  const openFile: openFileType = async ({ fileId, analytics }) => {
    navigation.navigateDeprecated("File", {
      id: fileId,
    });

    InteractionManager.runAfterInteractions(() => {
      accessFile({
        variables: {
          fileId,

          position: analytics?.position ? analytics.position + 1 : undefined,
          queryId: analytics?.queryId,
        },
      });
    });
  };

  return openFile;
};

export type openFileType = (_: {
  url: string;
  fileId: string;
  fileName: string;
  fileType: any;
  analytics?:
    | {
        position?: number | undefined;
        queryId?: string | undefined;
      }
    | undefined;
}) => Promise<void>;
